import { render, staticRenderFns } from "./beforeLoginLayout.vue?vue&type=template&id=8bbfbf92&scoped=true&"
import script from "./beforeLoginLayout.vue?vue&type=script&lang=js&"
export * from "./beforeLoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./beforeLoginLayout.vue?vue&type=style&index=0&id=8bbfbf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbfbf92",
  null
  
)

export default component.exports